export default __webpack_public_path__ + "static/media/wistor-mark-color.27e292d1.svg";